window.onerror = function (msg, source, lineNo, columnNo, error) {
    if (!window.clientErrorLogActionUrl) {
        return false;
    }

    // invoking error handling function after a timeout to give browser detection scripts time to load
    setTimeout(
        function () {

            // ignoring errors in unsupported browsers
            if (window.browserUpdateOutdated) {
                return false;
            }

            // ignoring weird errors with no source or url
            if (!source || !window || !window.location || !window.location.href || source === null || source === "undefined" || typeof(source) !== "string") {
                return false;
            }

            var sourceNoise = ["chrome-extension", "salesiq.zoho",
                "browser-update", "moz-extension", "addthis.com", "smigro.info", 
                "webvpn.hfut.edu.cn", "libproxy.hzau.edu.cn", "wwebvpn.sdjtu.edu.cn", "sec.xyafu.edu.cn", "scfw.cqut.edu.cn"];

            var isNoise = false,
                lowerCaseSource = source.toLowerCase();

            $.each(sourceNoise, function (index, noiseEntry) {
                if (lowerCaseSource.indexOf(noiseEntry) > -1) {
                    isNoise = true;

                    return false;
                }
            });

            if (isNoise) {
                return false;
            }

            // ignoring errors that occured in vendors scripts
            // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#Notes
            var messageNoise = ["script error", "addthis.",
                "blocked a frame with origin", "vid_mate_check is not defined",
                "cannot read property 'search' of undefined", "fixedtimeid is not defined",
                "the operation is insecure", "access is denied.",
                "bq is not defined", "can't redefine non-configurable property",
                "exception thrown and not caught", "unexpected token [ in json",
                "$buo is not defined", "globalize is not defined",
                "cannot read property 'tagname' of null", "json parse error: unexpected identifier \"object\"",
                "a[b].target.classname.indexof is not a function", "'FormData' is undefined",
                "fb is not defined", "'formdata' is undefined", "ResizeObserver loop limit exceeded",
                "Cannot read property 'getReadModeExtract' of undefined"];

            var lowerCaseMessage = msg.toLowerCase();

            $.each(messageNoise, function (index, noiseEntry) {
                if (lowerCaseMessage.indexOf(noiseEntry.toLowerCase()) > -1) {
                    isNoise = true;

                    return false;
                }
            });

            if (isNoise) {
                return false;
            }

            var clientError = {
                message: msg,
                source: source,
                line: lineNo,
                column: columnNo,
                url: window.location.href,
                referrer: document.referrer
            };

            if (error) {

                StackTrace.fromError(error)
                    .then(function (stackFrames) {

                        var mappedCallStack = stackFrames.map(
                                function (frame) {
                                    return frame.toString();
                                })
                            .join("\n");

                        clientError.stack = mappedCallStack;

                        $.post(window.clientErrorLogActionUrl, clientError);
                        window.clientErrorLogActionUrl = null;
                    })
                    .catch(function (parserError) {
                        $.post(window.clientErrorLogActionUrl, clientError);
                        window.clientErrorLogActionUrl = null;
                    });
            } else {

                $.post(window.clientErrorLogActionUrl, clientError);
                window.clientErrorLogActionUrl = null;
            }

            return false;

        }, 200);

    return false;
};
